import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./UserAdmin.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IUserAdmin } from "./IUserAdmin";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";

import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listExam } from "../../Redux/Slices/Exam/ListExamSlice";
import { clearAddUserAdminResponse } from "../../Redux/Slices/UserAdmin/AddUserAdminSlice";
import { clearEditUserAdminResponse } from "../../Redux/Slices/UserAdmin/EditUserAdminSlice";
import {
  clearDeleteUserAdminResponse,
  deleteUserAdmin,
} from "../../Redux/Slices/UserAdmin/DeleteUserAdminSlice";
import UserAdminForm from "./UserAdminForm";
import { listUserAdmin } from "../../Redux/Slices/UserAdmin/ListUserAdminSlice";
import { listRole } from "../../Redux/Slices/Role/ListRoleSlice";

interface UserAdminProps {}

const UserAdmin: FunctionComponent<UserAdminProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IUserAdmin>({});
  const dispatch = useAppDispatch();
  const { data: ListUserAdmin } = useAppSelector(
    (state) => state.ListUserAdminSlice
  );
  const { data: addUserAdmin } = useAppSelector(
    (state) => state.AddUserAdminSlice
  );
  const { data: EditUserAdmin } = useAppSelector(
    (state) => state.EditUserAdminSlice
  );
  const { data: deleteUserAdmins } = useAppSelector(
    (state) => state.DeleteUserAdmin
  );

  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "userprofile";

  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[1];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "username",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params.row.username === null ? "-" : params.row.username}
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      renderHeader: () => <b>Email ID</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "phone_no",
      renderHeader: () => <b>Mobile Number</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params.row.phone_no === null ? "-" : params.row.phone_no}
            </div>
          </>
        );
      },
    },
    {
      field: "role",
      renderHeader: () => <b>Role</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params.row.role_name === null ? "-" : params.row.role_name}
            </div>
          </>
        );
      },
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IUserAdmin>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({
                  id: params.id,
                  name: params?.row?.username,
                });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const UserAdmin = Array.isArray(ListUserAdmin?.data)
    ? ListUserAdmin?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(
      listUserAdmin({
        rolename: "ADMIN",
      })
    );
    dispatch(listRole());
    // dispatch(listSideMenuPermission());
  }, [addUserAdmin, EditUserAdmin, deleteUserAdmins, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddUserAdminResponse());
      dispatch(clearEditUserAdminResponse());
      dispatch(clearDeleteUserAdminResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={UserAdmin ?? []} columns={columns}>
        <CustomToolbar>
          {/* <h6>Staff</h6> */}
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => setDialogOpen(true)}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() =>
              dispatch(
                listUserAdmin({
                  rolename: "ADMIN",
                })
              )
            }
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${
          (initialValues as IUserAdmin).id ? "Update" : "Add"
        } User`}
        Dialog_Content={
          <UserAdminForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addUserAdmin} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditUserAdmin} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteUserAdmin(deleteDialogData.id));
        }}
        response={deleteUserAdmins}
      />
    </>
  );
};

export default UserAdmin;
